import { render, staticRenderFns } from "./CalcBody.vue?vue&type=template&id=1d4df172&scoped=true&"
import script from "./CalcBody.vue?vue&type=script&lang=js&"
export * from "./CalcBody.vue?vue&type=script&lang=js&"
import style0 from "./CalcBody.vue?vue&type=style&index=0&id=1d4df172&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4df172",
  null
  
)

export default component.exports